module.exports = __webpack_public_path__ + "static/media/culture.1f8b92b0.svg";